"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processEnv = processEnv;
exports.augmentEnvWithDefaults = augmentEnvWithDefaults;
exports.deepTransformStrings = deepTransformStrings;
exports.interpolateEnv = interpolateEnv;
const lodash_1 = __importDefault(require("lodash"));
/**
 * Process environment arguments attached ProjectConfig.
 *
 * @param {ProjectConfig} baseConfig
 * @returns {T}
 */
function processEnv(baseConfig) {
    augmentEnvWithDefaults(baseConfig);
    return deepTransformStrings(interpolateEnv, baseConfig);
}
/**
 * Process $envDefaults arguments attached to ProjectConfig.
 *
 * @param {ProjectConfig} baseConfig
 */
function augmentEnvWithDefaults(baseConfig) {
    const envDefaults = baseConfig && baseConfig["$envDefaults"];
    if (envDefaults && lodash_1.default.isObject(envDefaults)) {
        Object.keys(envDefaults).forEach((k) => {
            process.env[k] = process.env[k] || String(envDefaults[k]);
        });
    }
}
/**
 * Helper that runs a provided transform function on a string or collection
 * of strings.
 *
 * @returns the transformed string or collection.
 */
function deepTransformStrings(transform, val) {
    if (lodash_1.default.isString(val)) {
        return transform(val);
    }
    else if (lodash_1.default.isArray(val)) {
        return val.map((v) => deepTransformStrings(transform, v));
    }
    else if (lodash_1.default.isObject(val)) {
        return lodash_1.default.mapValues(val, (v) => deepTransformStrings(transform, v));
    }
    else {
        return val;
    }
}
/**
 * Helper that processes `${envName}` syntax in a string, replacing it
 * with a value from process.env.
 *
 * @param {string} raw
 * @returns {string}
 */
function interpolateEnv(raw) {
    const re = /\$\$|\$\{([A-Za-z0-9_]+)\}/g;
    let currIndex = 0;
    const parts = [];
    let m = re.exec(raw);
    while (m) {
        parts.push(raw.slice(currIndex, m.index));
        currIndex = m.index + (m[0] || []).length;
        if (m[0] === "$$") {
            parts.push("$");
        }
        else {
            const envVarName = m[1] || "";
            parts.push(process.env[envVarName] || "");
        }
        m = re.exec(raw);
    }
    return parts.join("") + raw.slice(currIndex);
}
//# sourceMappingURL=ProjectConfig.js.map